import { Box, Typography, useMediaQuery } from '@mui/material'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SearchBar from '../../../components/PageHelpers/SearchBar.jsx'
import LoadMore from '../../../components/Buttons/LoadMore.jsx'
import Loader from '../../../components/helpers/Loader.jsx'
import CustomerAdminUsersCard from './CustomerAdminUsersCard'
import { customerAdminSelectUsers } from '../../../redux/features/users/customerAdmin/customerAdminSlice'
import {
  customerAdminRetrieveUsers,
  customerAdminSearchUsers,
  customerAdminUsersPagination,
} from '../../../redux/features/users/customerAdmin/customerAdminThunk'
import CookiesStorageService from '../../../services/CookiesStorageService'
import PageFilter from './PageFilters/index'
import UseTranslation from '../../../hooks/UseTranslation.jsx'

const Index = () => {
  const username = CookiesStorageService.getUserName()
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const dispatch = useDispatch()
  const users = useSelector(customerAdminSelectUsers)
  const { t } = UseTranslation()
  useEffect(() => {
    dispatch(customerAdminRetrieveUsers())
  }, [])
  return (
    <Box sx={styles.container}>
      <Box sx={styles.titleBox}>
        <Typography sx={styles.welcomeHeader}>{t?.Welcome} , {username}</Typography>
        {!isXsScreen && (<SearchBar
          actionToDispatch={customerAdminSearchUsers}
          searchPlaceholder={t?.['Search for user by username or Email Address']}
          customStyles={styles.searchBarContainer}
        />)}
      </Box>
      <PageFilter />
      <Box sx={styles.userListContainer}>
      {users.value?.map((user) => (
          <CustomerAdminUsersCard user={user} key={user.id} />
      ))}
        </Box>

      <LoadMore actionToDispatch={customerAdminUsersPagination} store={users} />
      <Loader store={users} />
    </Box>
  )
}

const styles = {
  container: {
    padding: { xs: '10px 20px', sm: '0 70px' },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  titleBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    width: '100%',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    svg: {
      fontSize: { xs: '20px', sm: 'unset' },
      marginTop: { xs: '10px', sm: 'unset' },
    },
  },
  welcomeHeader: {
    fontSize: { xs: '16px', sm: '24px' },
  },
  searchBarContainer: {
    paddingTop: { xs: '10px', sm: 'unset' },
    input: {
      fontSize: { xs: '11px', sm: 'unset' },
    },
  },
  userListContainer: {
    width: '100%',
  },
}

export default Index
